<template>
  <div class="off-bckgr-container-full">
    <my-header
      :page_name="$t('navigation.headerTitles.sectionTasks')"
      show_usermenu
    ></my-header>

    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t("sectionTasks.server") }}</label>
        <el-select v-model="serverSelected" @change="serverChanged" filterable>
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
      </div>
      <div class="settings-element">
        <label>{{ $t("sectionTasks.app") }}:</label>
        <el-select v-model="appSelected" @change="appChanged" filterable>
          <el-option disabled value>{{
            $t("sectionTasks.appNotSelected")
          }}</el-option>
          <el-option
            v-for="(app, index) in getAppsArray"
            :key="index"
            :value="app.id"
            :label="app.alias?app.name+' ('+app.alias+')':app.name"
          ></el-option>
        </el-select>
      </div>
    </div>
    <transfer
      v-if="!!serverSelected && !!appSelected"
      :leftList="leftList"
      :rightList="rightList"
      :titlesNames="[
        $t('sectionTasks.launchAllowed'),
        $t('sectionTasks.launchDenied'),
      ]"
      :buttonsNames="[
        $t('sectionTasks.deniedLaunch'),
        $t('sectionTasks.allowLaunch'),
      ]"
      @leftListClick="leftListClick"
      @rightListClick="rightListClick"
    ></transfer>
  </div>
</template>


<script>
import Header from "../../components/reusable/header/Header";
import Transfer from "../../components/config/linking/Transfer";
import { mapGetters } from "vuex";
function createData(tasksArray) {
  const data = [];
  tasksArray.forEach((task) => {
    data.push({
      id: parseInt(task.idTask),
      label: `${task.caption}`,
      disabled: false,
    });
  });
  return data;
}
export default {
  data() {
    return {
      serverSelected: null,
      appSelected: null,
      leftList: [],
      rightList: [],
    };
  },
  methods: {
    serverChanged() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getApps", { serverSelected: this.serverSelected })
        .then(() => {
          this.setData("server", this.serverSelected);
          this.$store.commit("setLoading", false);
          this.appSelected = null;
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
          this.appSelected = null;
        });
    },
    appChanged() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getTasksInSection", this.appSelected)
        .then(() => {
          return this.$store.dispatch("getTasksNotInSection", this.appSelected);
        })
        .then(() => {
          let object = {
            server: this.serverSelected,
            app: this.appSelected,
          };
          this.$localStorage.set("wa-sectionTasks", JSON.stringify(object));
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    leftListClick(value) {
      this.$store.commit("setLoading", true);

      //console.log("left click", value);
      this.$store
        .dispatch("unlinkTasksSection", {
          sectionId: this.appSelected,
          idArray: value,
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    rightListClick(value) {
      this.$store.commit("setLoading", true);
      //console.log("right click", value);
      this.$store
        .dispatch("linkTasksSection", {
          sectionId: this.appSelected,
          idArray: value,
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  created() {
    if (this.$localStorage.get("wa-sectionTasks")) {
      let savedData = JSON.parse(this.$localStorage.get("wa-sectionTasks"));
      if (!!savedData && savedData.server && savedData.app) {
        this.$store.commit("setLoading", true);
        if (!this.getServersArray.find((s) => s.id === savedData.server)) {
          return;
        }
        this.serverSelected = savedData.server;
        this.$store
          .dispatch("getApps", {serverSelected: this.serverSelected})
          .then(() => {
            if (!this.getAppsArray.find((a) => a.id === savedData.app)) {
              return;
            }
            this.appSelected = savedData.app;
            return this.$store.dispatch("getTasksInSection", this.appSelected);
          })
          .then(() => {
            return this.$store.dispatch(
              "getTasksNotInSection",
              this.appSelected
            );
          })
          .then(() => {
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      }
    }
  },
  computed: {
    ...mapGetters([
      "getServersArray",
      "getAppsArray",
      "tasksInSection",
      "tasksNotInSection",
    ]),
  },
  watch: {
    tasksInSection() {
      this.leftList = createData(this.tasksInSection);
    },
    tasksNotInSection() {
      this.rightList = createData(this.tasksNotInSection);
    },
  },
  components: {
    myHeader: Header,
    Transfer,
  },
};
</script>
